module.exports = __webpack_public_path__ + "img/hetianxia.add15ad3.jpg";